import { DocRenderer } from '@cyntler/react-doc-viewer';
import { ClickAwayListener } from '@material-ui/core';
import { useContext } from 'react';

import { ClickAwayContext } from './context';

export const VideoRenderer: DocRenderer = ({ mainState }) => {
  const videoSrc = mainState.currentDocument?.uri || '';
  const { onClickAway } = useContext(ClickAwayContext);
  return (
    <div className="h-screen w-full flex justify-center items-center">
      <ClickAwayListener onClickAway={onClickAway}>
        <video
          autoPlay
          controls
          src={videoSrc}
          className="h-full h-fill-available sm:w-auto w-3/4 border-none mt-16 max-w-full"
        />
      </ClickAwayListener>
    </div>
  );
};

VideoRenderer.fileTypes = ['video/mp4', 'video/quicktime', 'video/mov'];
VideoRenderer.fileLoader = ({ fileLoaderComplete }) => {
  // Rather than fetching the file and show the loading spinner, we can directly render the video
  // since we already have the file uri and the video player can buffer the video.
  fileLoaderComplete();
};
VideoRenderer.weight = 1;
